module.exports = __webpack_public_path__ + "img/mat_406.f60752ac.png";